<ng-container *ngFor="let item of navigationItems" class="section-menu">
  <a
    class="section-menu__item"
    (click)="trackNavigateEvent(item)"
    [routerLink]="item.routerLink"
    *visibility="{
      featureFlag: item.featureFlagModule || null,
      permissionKey: item.permissionKey || null
    }"
    [attr.data-name]="item.name | translate | titlecase"
    [attr.data-cy]="item.dataCy"
  >
    <span>{{ navigationService.navNameTranslation(item.name) }}</span>
  </a>
</ng-container>
